galleryFilterSelection("people") // Execute the function and show first block columns
function galleryFilterSelection(c) {
	var x, i;
	x = document.getElementsByTagName("img");
	// if (c == "people") c = "";
	// Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
	for (i = 0; i < x.length; i++) {
		galleryRemoveClass(x[i], "show");
		if (x[i].className.indexOf(c) > -1) galleryAddClass(x[i], "show");
	}
}

// Show filtered elements
function galleryAddClass(element, name) {
	var i, arr1, arr2;
	arr1 = element.className.split(" ");
	arr2 = name.split(" ");
	for (i = 0; i < arr2.length; i++) {
		if (arr1.indexOf(arr2[i]) == -1) {
			element.className += " " + arr2[i];
		}
	}
}

// Hide elements that are not selected
function galleryRemoveClass(element, name) {
	var i, arr1, arr2;
	arr1 = element.className.split(" ");
	arr2 = name.split(" ");
	for (i = 0; i < arr2.length; i++) {
		while (arr1.indexOf(arr2[i]) > -1) {
			arr1.splice(arr1.indexOf(arr2[i]), 1);
		}
	}
	element.className = arr1.join(" ");
}

$(window).on('load', function () {

	// Gallery Filter
	// var $grid = $('.gallery .grid').imagesLoaded(function () {
	// 	$grid.isotope({
	// 		itemSelector: '.imgGrid',
	// 		filter: $('.gallery .button-group').find('.is-checked').attr('data-filter'),
	// 		percentPosition: true,
	// 		masonry: {
	// 			// columnWidth: 50,
	// 			columnWidth: '.grid-sizer',
	// 			gutter: 10,
	// 			horizontalOrder: true,
	// 			// fitWidth: true
	// 		}
	// 	});
	// });

	$('.gallery .button-group').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'button', function () {
			$buttonGroup.find('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
			galleryFilterSelection($(this).attr('data-filter'))
		});
	});

	// $('.gallery .button-group').on('click', 'button', function () {
	// 	var filterValue = $(this).attr('data-filter');
	// 	$grid.isotope({ filter: filterValue });
	// });



	// Job Filter
	var $jobGrid = $('.jobs .listings').imagesLoaded(function () {
		$jobGrid.isotope({
			itemSelector: '.job'
		});
	});

	$('.jobs .button-group').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'button', function () {
			$buttonGroup.find('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
		});
	});

	$('.jobs .button-group').find('button', function () {
		var filterValue = $(this).attr('data-filter');
		$jobGrid.isotope({ filter: filterValue });
	});

	$('.jobs .button-group').on('click', 'button', function () {
		var filterValue = $(this).attr('data-filter');
		$jobGrid.isotope({ filter: filterValue });
	});
});

$(document).ready(function () {

	function mainSpace() {
		let headerHeight = $('header').innerHeight();
		$('main').css('margin-top', headerHeight);
	}
	mainSpace();

	$(window).scroll(function () {
		30 < $(this).scrollTop() ? $("header").addClass('sticky-menu') : $("header").removeClass('sticky-menu')
	});

	function scrollNav() {
		$('.navbar-links ul li>a').click(function () {
			//Toggle Class
			$(".active").removeClass("active");
			$(this).closest('li').addClass("active");
			var theClass = $(this).attr("class");
			$('.' + theClass).parent('li').addClass('active');
			//Animate
			$('html, body').stop().animate({
				scrollTop: $($(this).attr('href')).offset().top - 75
			}, 200);
			return false;
		});
		$('.scrollTop a').scrollTop();
	}
	scrollNav();

	function scrollNav2() {
		$('#my-menu ul>li a').click(function () {
			$(".active").removeClass("active");
			$(this).closest('li').addClass("active");
			var theClass = $(this).attr("class");
			$('.' + theClass).parent('li').addClass('active');
			//Animate
			$('html, body').stop().animate({
				scrollTop: $($(this).attr('href')).offset().top - 80
			}, 200);
			return false;
		});
		$('.scrollTop a').scrollTop();
	}
	scrollNav2();

	$("#my-menu ul>li a").click(function () {
		$("body").removeClass("mm-ocd-opened");
		$(".mm-ocd--left").removeClass("mm-ocd--open");
	});

	$('.firstVideo, .secondVideo, .thirdVideo').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false
	});

	$('.form-modal').magnificPopup({
		type: 'inline',
		midClick: true,
		mainClass: 'mfp-fade'
	});

	$('.share-modal').magnificPopup({
		type: 'inline',
		midClick: true,
		mainClass: 'mfp-fade'
	});

});

document.addEventListener(
	"DOMContentLoaded", () => {
		const menu = new MmenuLight(
			document.querySelector("#my-menu"),
			"(max-width: 767px)"
		);

		const navigator = menu.navigation();
		const drawer = menu.offcanvas();

		document.querySelector("a[href='#my-menu']")
			.addEventListener("click", (evnt) => {
				evnt.preventDefault();
				drawer.open();
			});
	}
);

